import {db} from "@/main";
import User from "@/models/User.js";

export default {
	namespaced: true,
	state: {
		messages: new Map(),
		firebaseMessages: {},
		firebaseTotalSeen: {},
	},
	actions: {
		getNotyfications({commit}, ruta) {
			return db.ref(ruta).once("value");
		},
		getRef({commit}, data) {
			return db.ref(data);
		},
		update({commit}, data) {
			return db.ref().update(data);
		},
		updateData({commit}, el, data) {
			return db.ref(el).update(data);
		},
		detachEvent(state, data) {
			db.ref(data).off();
		},
		async getMessages(state, resourceid) {
			const user = new User();
			const userInfo = await user.getUser();
			return new Promise(function (resolve, reject) {
				// Create a root reference
				const database = firebase.database();
				const starCountRef = database.ref(`messages/${userInfo.company_id}/${resourceid}`).orderByChild("date");
				try {
					starCountRef.once("value", (snapshot) => {
						const messages = [];
						snapshot.forEach((childSnapshot) => {
							// key will be "ada" the first time and "alan" the second time
							let key = childSnapshot.key;
							// childData will be the actual contents of the child
							let childData = {...childSnapshot.val(), id: key};
							messages.push(childData);
						});
						resolve(messages);
					});
				} catch (error) {
					reject(error);
				}
			});
		},
		async getMessagesNotyfications({state, commit}, resourceid) {
			const user = new User();
			const userInfo = await user.getUser();
			return new Promise((resolve, reject) => {
				// Create a root reference
				const starCountRef = db.ref(`messages/${userInfo.company_id}/${resourceid}`).orderByChild("date");
				try {
					starCountRef.on("value", (snapshot) => {
						const messages = [];
						commit("clearMessages", resourceid);

						snapshot.forEach((childSnapshot) => {
							// key will be "ada" the first time and "alan" the second time
							let key = childSnapshot.key;
							// childData will be the actual contents of the child
							let childData = {...childSnapshot.val(), id: key};
							messages.push({...childData, resource_id: resourceid});
						});

						commit("setMessages", {messages, resource_id: resourceid});
						resolve(messages);
					});
				} catch (error) {
					reject(error);
				}
			});
		},
	},
	mutations: {
		clearMessages(state, resourceid) {
			state.firebaseMessages[resourceid] = [];
		},
		setMessages(state, {messages, resource_id}) {
			state.firebaseMessages[resource_id] = messages;
			state.firebaseTotalSeen[resource_id] = messages.filter((message) => !message.seen).length;
		},
		resetProgress(state) {
			// `state` is the local module state
			state.uploadProgress = 0;
		},
	},
};
